export class GetCompanyConfigurationInput {
    companyId: string;

    constructor(companyId: string) {
        this.companyId = companyId;
    }
}
